import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import RequestHelper from "../../../helpers/RequestHelper";
import { getGenelDurumString } from "../../../features/loadingMessageSlice";
import { getCurrentUser } from "../../../features/currentUserSlice";
import GenelDurumHelper, { GenelDurumLoginStateHelper } from "../../../helpers/GenelDurumHelper";
import { IMainScreenProps, MainLayout } from "../../../components/layout/MainLayout";
import AlertHelper from "../../../library/helpers/AlertHelper";
import { GuidHelper } from "../../../library/helpers/GuidHelper";
import { mainScreenLocations } from "../../../app/mainScreens";
import { BildirimModel } from "../../../models/businessModels/BildirimModel";
import { useTranslation } from "react-i18next";
import TranslationHelper from "../../../helpers/TranslationHelper";
import DateTimeHelper from "../../../library/helpers/DateTimeHelper";
import { EnmBildirimTip } from "../../../models/enums/EnmBildirimTip";
import Rows from "../../../library/components/layout/Rows";
import VatanKoroSelectField from "../../../components/vatan/VatanKoroSelectField";
import { HesapBilgiVeKullaniciModel } from "../../../models/businessModels/HesapBilgiVeKullaniciModel";
import StringHelper from "../../../library/helpers/StringHelper";
import OzelGrupluKisiAvatarListControl from "../../../components/business/OzelGrupluKisiAvatarListControl";
import { EnmSesGrupTip } from "../../../models/enums/EnmSesGrupTip";
import { SesGrupModel } from "../../../models/businessModels/SesGrupModel";

function BildirimYonetimScreen() {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const translate = TranslationHelper.TransFunc(t);
  const requestHelper = RequestHelper(navigate, dispatch, translate);

  const genelDurum = GenelDurumHelper.StringToModel(useAppSelector(getGenelDurumString)!)!;
  const user = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (!user.token || genelDurum == null) {
      GenelDurumLoginStateHelper.GenelDurumYukleVeKoroAyarla(requestHelper, navigate, dispatch, user, genelDurum);
    }
  })

  if (!user.token || genelDurum == null) {
    return <></>;
  }

  const genelDurumHelper = new GenelDurumHelper(genelDurum, user, translate, navigate, dispatch, i18n, requestHelper);

  return <BildirimYonetimScreenInner genelDurumHelper={genelDurumHelper} />
}

function BildirimYonetimScreenInner(props: IMainScreenProps) {
  const { genelDurumHelper } = props;

  const [seciliKoroId, setSeciliKoroId] = useState<string>("");

  function bildirimOlustur(hesap: HesapBilgiVeKullaniciModel, mesaj: string) {
    const bildirimModel = new BildirimModel();
    bildirimModel.id = GuidHelper.NewGuid();
    bildirimModel.koroModelId = hesap.koroModelId;
    bildirimModel.kullaniciAdi = hesap.kullaniciModel.kullaniciAdi;
    bildirimModel.gonderimTarihi = DateTimeHelper.now();
    bildirimModel.icerik = mesaj;
    bildirimModel.eserId = GuidHelper.Empty;
    bildirimModel.calismaId = GuidHelper.Empty;
    bildirimModel.bildirimTipi = EnmBildirimTip.Özel;
    bildirimModel.okundu = false;

    bildirimModel.olusturan = genelDurumHelper.genelDurum.kullanici.kullaniciAdi;
    bildirimModel.olusturmaTarih = new Date();

    return bildirimModel;
  }


  const seciliKoro = genelDurumHelper.genelDurum.korolar.singleOrDefault(e => e.koroModel.id === seciliKoroId);

  const tumKullanicilar = seciliKoro?.hesapBilgiList ?? [];
  const aktifKullanicilar = tumKullanicilar.where(e => e.aktif);

  // const anaKadro = seciliKoro?.tumKadrolar.where(e => e.sezonModelId === seciliKoro?.sezonModelId)?.orderBy(e => e.olusturmaTarih).firstOrDefault();
  // const anaKadroId = anaKadro?.id ?? "";

  const gosterilecekSesGruplari = seciliKoro?.tumSesGruplari.where(e => e.sesGrupTip === EnmSesGrupTip["Alt Ses Grubu"]) ?? [];

  const gercek_gosterilecekSesGruplari = [...gosterilecekSesGruplari, null]

  async function mesajGonder(hesap: HesapBilgiVeKullaniciModel) {
    const response = await AlertHelper.ConfirmWithTextInput("Gönderilecek mesajı girin", "Mesaj İçeriği", true);

    if (StringHelper.isEmpty(response))
      return;

    const bildirimModel = bildirimOlustur(hesap, response!);

    const webResponse = await genelDurumHelper.requestHelper.Genel.Bildirim(bildirimModel);
    if (!webResponse.successfull)
      return;
  }

  return (
    <MainLayout
      location={mainScreenLocations.bildirimYonetim}
      genelDurumHelper={genelDurumHelper}
      hideHeader={false}
      hideMenu={false}>

      <Rows flex ml={10} mr={10} mb={10} mt={20} gap={10}>
        <VatanKoroSelectField
          onChange={e => setSeciliKoroId(e!)}
          label={genelDurumHelper.translate("Seçili Koro")}
          value={seciliKoroId}
          tumKorolar={genelDurumHelper.genelDurum.korolar.select(e => e.koroModel)}
          genelDurumHelper={genelDurumHelper}
        />
        <OzelGrupluKisiAvatarListControl
          darkSeperator
          thumbnailSize="normal"
          gosterilecekHesaplar={aktifKullanicilar}
          tumHesaplar={aktifKullanicilar}
          hesapGrupGetir={e => gercek_gosterilecekSesGruplari.firstOrDefault(t => e.sesGrupIdList.contains(t?.id ?? ""))}
          grupIsimGetir={(e: SesGrupModel | null) => e?.isim ?? "Diğer"}
          hesapGrupSortFunc={(e: SesGrupModel| null) => e?.sira ?? -5}
          onClick={mesajGonder}
          genelDurumHelper={genelDurumHelper}
        />
      </Rows>
    </MainLayout>
  );
}

export default BildirimYonetimScreen;
